import type {
  CompositeAttractivenessResponse,
  FinancialHealthResponse,
  LayerScore,
} from '@/services/api';

function emptyLayer(): LayerScore {
  return {
    score: 0,
    interpretation: 'neutral',
    trend: null,
    components: [],
    metadata: {},
  };
}

export function createDisabledAttractivenessStub(ticker: string): {
  scoreResult: CompositeAttractivenessResponse;
  financialHealth: FinancialHealthResponse;
} {
  const timestamp = new Date().toISOString();
  const financialHealthLayer = emptyLayer();

  const scoreResult: CompositeAttractivenessResponse = {
    symbol: ticker,
    composite_score: 0,
    interpretation: 'neutral',
    layer_breakdown: {
      financial_health: financialHealthLayer,
      analyst_expectations: emptyLayer(),
      market_dynamics: emptyLayer(),
    },
    weights: {
      financial_health: 0.3333,
      analyst_expectations: 0.3333,
      market_dynamics: 0.3334,
    },
    trend_summary: null,
    signals: [],
    timestamp,
    error: null,
  };

  const financialHealth: FinancialHealthResponse = {
    symbol: ticker,
    layer_name: 'financial_health',
    composite_score: 0,
    interpretation: 'neutral',
    components: [],
    trend: null,
    trend_data: null,
    timestamp,
    metadata: {
      sector_type: 'unknown',
      sector_name: 'Unknown',
      industry_name: 'Unknown',
      model_name: 'Disabled',
      model_description: '',
      limitations: [],
      use_sector_models: true,
    },
    error: null,
  };

  return { scoreResult, financialHealth };
}
